import { environment } from '@environments/environment';
import { constants } from '@shared/constants/constants';
import { PerformanceType } from '@shared/models/performance';
import { LabelTextPipe } from '@shared/pipes/label-text.pipe';

export function getMandatGestionUiLibelle(label: string, performanceType?: PerformanceType): string {
  const isPeri: boolean = environment.orgId === constants.orgId.peri.value;

  let uiLabel = '';

  switch (label) {
    case constants.prudent.name: {
      uiLabel = constants.prudent.uiName;
      break;
    }
    case constants.equilibré.name: {
      uiLabel = constants.equilibré.uiName;
      break;
    }
    case constants.dynamiqueA.name: {
      uiLabel = constants.dynamiqueA.uiName;
      break;
    }
    case constants.dynamiqueR.name: {
      uiLabel = constants.dynamiqueR.uiName;
      break;
    }
    case constants.offensif.name: {
      uiLabel = constants.offensif.uiName;
      break;
    }
    case constants.modere.name: {
      if (isPeri) {
        uiLabel = constants.equilibré.uiName;
      } else {
        uiLabel = constants.modere.uiName;
      }

      break;
    }
    default: {
      uiLabel = label;
      break;
    }
  }

  return uiLabel;
}

export function getFundChartPaymentMinimumText(labelTextPipe: LabelTextPipe): string {
  const isCems: boolean = environment.orgId === constants.orgId.cems.value;
  const isCims: boolean = environment.orgId === constants.orgId.cims.value;
  const isPeri: boolean = environment.orgId === constants.orgId.peri.value;

  if (isCems) {
    return labelTextPipe.transform('Recommendation.FundChartPaymentMinimumCEMS');
  }

  if (isCims) {
    return labelTextPipe.transform('Recommendation.FundChartPaymentMinimumCIMS');
  }

  if (isPeri) {
    return labelTextPipe.transform('Recommendation.FundChartPaymentMinimumPERI');
  }

  return labelTextPipe.transform('Recommendation.FundChartPaymentMinimum');
}
